import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const PaymentTypeServices = {
  getList: async () => {
    const response = await apiService.get("/paymenttypes");
    return response.data;
  },
  create: async (data) => {
    try {
      const response = await apiService.post(`/paymenttypes`, data);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  update: async (id, data) => {
    try {
      const response = await apiService.put(`/paymenttypes/${id}`, data);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  delete: async (id) => {
    const response = await apiService.delete(`/paymenttypes/${id}`);
    return response.data;
  },
};

export default PaymentTypeServices;
